import React, { useState, useEffect } from "react";
import { IconButton, Link, Typography } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import { isMobile, isChrome, isFirefox, isEdgeChromium, isSafari } from "react-device-detect";

const UnsupportedBrowserAlert = () => {
  const [showAlert, setShowAlert] = useState(true);
  const closeAlert = () => setShowAlert(false);

  useEffect(() => {
    const isSupportedBrowser = isChrome || isFirefox || isEdgeChromium || isSafari;
    if (isMobile || isSupportedBrowser) {
      closeAlert();
    }
  }, []);

  return showAlert ? (
    <Alert
      variant="filled"
      severity="error"
      action={
        <IconButton aria-label="close" color="inherit" size="small" onClick={closeAlert}>
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
    >
      <AlertTitle>Unsupported Browser</AlertTitle>
      <Typography paragraph>
        You are currently using an unsupported browser, so a few features might not work. Please try
        downloading a modern browser like Safari,
        {` `}
        <Link href="https://www.microsoft.com/en-us/edge">Edge</Link>,{` `}
        <Link href="https://www.google.com.au/intl/en_au/chrome/">Chrome</Link>
        {` `}
        or <Link href="https://www.mozilla.org/en-US/firefox/new/">Firefox</Link>.
      </Typography>
    </Alert>
  ) : (
    <></>
  );
};

export default UnsupportedBrowserAlert;
